import { DATA_SCOPE_LABELS, ROLE_LABELS } from '@fos/shared/labels';
import { LogOut } from 'lucide-react';
import type { ReactNode } from 'react';
import { useSignOut } from '../../../app/layout/UserMenus';
import { useActiveSession } from '../../../lib/auth';
import { Avatar } from '../../../ui/Avatar';
import { Button } from '../../../ui/Button';
import { Section } from '../../../ui/Section';
import { TOUCH_BUTTON } from '../../mobile';
import { CalendarInviteSection } from './CalendarInviteSection';
import { PrimaryWorkspaceSection } from './PrimaryWorkspaceSection';
import { SettingsHeader } from './SettingsLayout';

/** Ustawienia → Profil (Fala 0: podgląd; edycja imienia i koloru w Fali 1). Czeka na projekt w Figmie. */
export function ProfilePage() {
  const session = useActiveSession();
  const signOut = useSignOut();
  const role = session.membership?.role;

  return (
    <div>
      <SettingsHeader title="Profil" description="Twoje dane w Fravity OS. Edycja pojawi się wkrótce." />
      <Section className="mt-6" aria-label="Twoje dane">
        <div className="flex items-center gap-4">
          <Avatar initials={session.user.initials} color={session.user.avatarColor} size={40} />
          <div className="min-w-0">
            <p className="truncate text-body-m font-semibold text-fg">{session.user.name}</p>
            <p className="truncate text-body-s text-fg-muted">{session.user.email}</p>
          </div>
        </div>
        <dl className="mt-6 border-t border-line">
          <Row label="Imię i nazwisko">{session.user.name}</Row>
          <Row label="Email">{session.user.email}</Row>
          <Row label="Workspace">{session.workspace?.name ?? '—'}</Row>
          <Row label="Rola">{role ? ROLE_LABELS[role] : '—'}</Row>
          <Row label="Zakres danych">{session.access ? DATA_SCOPE_LABELS[session.access.dataScope] : '—'}</Row>
        </dl>
      </Section>
      <PrimaryWorkspaceSection />
      <CalendarInviteSection />
      <div className="mt-6">
        <Button variant="secondary" icon={LogOut} onClick={signOut} className={TOUCH_BUTTON}>
          Wyloguj
        </Button>
      </div>
    </div>
  );
}

function Row({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="flex min-h-[52px] flex-col justify-center gap-0.5 border-b border-line py-2 md:flex-row md:items-center md:gap-6">
      <dt className="text-body-s text-fg-muted md:w-44 md:shrink-0">{label}</dt>
      <dd className="min-w-0 truncate text-body-s text-fg">{children}</dd>
    </div>
  );
}
